<div #mapinstance class="baidu-map-element"></div>
@if ((mapInitialized | async) === true) {
    <h-map-baidu-marker
        [markers]="markers"
        [isInMobile]="isInMobile"
        [isZoomOnClickActive]="isZoomOnClickActive"
        [isMarkerClustererActive]="isMarkerClustererActive"
        (clickedMarkerCoordinates)="clickedMarkerCoordinates.emit($event)"
        (hoveredMarkerCoordinates)="hoveredMarkerCoordinates.emit($event)"
        (unhoveredMarkerCoordinates)="unhoveredMarkerCoordinates.emit($event)">
    </h-map-baidu-marker>
}
